import { getTimeSeriesSalesReport } from "@/api/report-api";
import { buildCacheKey, useCollectionData } from "@/hooks/use-api";
import { TimeSeriesGrouping, TimeSeriesSalesResponse } from "@/types/report-type";

export function useTimeSeriesSales(
    fromDate: string,
    toDate: string,
    grouping: TimeSeriesGrouping
) {
    const cacheKey = buildCacheKey("time-series-sales", { fromDate, toDate, grouping });

    return useCollectionData<TimeSeriesSalesResponse>(
        cacheKey,
        () => getTimeSeriesSalesReport(fromDate, toDate, grouping),
        {
            refreshInterval: 0,
            revalidateOnFocus: false,
        }
    );
}
